<template>
  <div id="sms-count-setting" class="shadow-md rounded-item">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <vs-tabs id="sms-count-setting-tabs" v-model="active_tab" vs-position="top">
            <vs-tab label="SMS Count">
              <sms-count-tab></sms-count-tab>
            </vs-tab>
            <vs-tab label="Recharge" disabled>
              <sms-recharge-tab></sms-recharge-tab>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

export default {
  name: "sms-count-setting",
  data() {
    return {
      active_tab: 0,
    };
  },
  
};
</script>